
import { mixin } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

import { BoxMaintenanceDocumentComponent } from "./document.box";
import { CloudMaintenanceDocumentComponent } from "./document.cloud";
import { DemoMaintenanceDocumentComponent } from "./document.demo";

export default class DocumentComponent extends mixin(environment.nexus, {
    box: BoxMaintenanceDocumentComponent,
    cloud: CloudMaintenanceDocumentComponent,
    demo: DemoMaintenanceDocumentComponent,
}) { }
